import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import { useState } from "react";
import PhotoGallery from "../../components/photoGallery/PhotoGallery";
import { F2020_2021, F2021_2022, F2022_2023 } from './Images';

const financialYears = [
    { id: 2, label: "Financial Year 2020-2021", data: F2020_2021 },
    { id: 3, label: "Financial Year 2021-2022", data: F2021_2022 },
    { id: 4, label: "Financial Year 2022-2023", data: F2022_2023 }
];

export default function Gallery() {
    const { fontSize } = useTheme();
    const [render, setRender] = useState(1);
    const [loading, setLoading] = useState(false);

    const load = (id) => {
        setLoading(true);
        setRender(id);
        setTimeout(() => {
            setLoading(false);
        }, 2500);
    };

    return (
        <Box sx={{}}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h1" sx={{ fontSize: `${fontSize + 0.5}rem`, margin: "5px 0" }}>
                    Photo Gallery {render === 1 ? ' ' : financialYears.find(year => year.id === render).label}
                </Typography>

                {render !== 1 &&
                    <i className="fa fa-arrow-left" style={{ cursor: "pointer", fontSize: "1.6rem", color: "gray" }} onClick={() => setRender(1)}> </i>
                }
            </div>
            <hr />
            {loading ?
                <Box sx={{ height: "90%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="h4">Loading....</Typography>
                </Box> :
                <Box>
                    {/* Render financial year folders */}
                    {render === 1 &&
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "left" }}>
                            {financialYears.map(year => (
                                <div key={year.id} style={{ maxWidth: "250px", cursor: "pointer", display: "flex", flexDirection: "column", maxWidth: "120px", margin: "10px", background: "#f5f5dc", alignItems: "center", borderRadius: "5px", boxShadow: "0 0 5px 1px gray", padding: "5px" }} 
                                onClick={() => load(year.id)}>
                                    <i className="fa fa-folder-open-o" aria-hidden="true" style={{ fontSize: "6rem", color: "gray" }}></i>
                                    <span>{year.label}</span>
                                </div>
                            ))}
                        </Box>
                    }
                    {/* Render photo gallery */}
                    {financialYears.map(year => render === year.id && <PhotoGallery key={year.id} data={year.data} />)}
                </Box>
            }
        </Box>
    );
}
